import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hrefLinks',
  standalone: true
})
export class HrefLinksPipe implements PipeTransform {

  transform(value: string): string {
    // return value;
    let toReturn = '';
    for (let i = value.length - 1; i >= 0; i++) {
      toReturn += value[i];
    }
    return toReturn;
  }

}
